module.exports = __webpack_public_path__ + "img/4door_stopped.32af06dc.svg";